'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@common/components';
import SvgChevronright from '@common/icon/SvgChevronright';
import { cn } from '@core/utils';
import useEmblaCarousel from 'embla-carousel-react';
import { useSearchParams } from 'next/navigation';
import { Suspense } from 'react';
import { ReviewDetailSessionPortal } from '@/app/donation/_components/ReviewDetailSessionPortal';
import { Image } from '@/components/client';
import { BREAKPOINTS } from '@/constants/breakpoints';
import { useMediaQuery } from '@/hooks/useMediaQuery';
import { openResponsiveDialog } from '@/stores/ResponsiveDialogStore';
import { PhotoReviewsModalContent } from '../gifts/[productNumber]/_components/PhotoReviewsModalContent';
interface PhotoReviewSwiperProps {
  photoReviewList: {
    fileUrl: string;
    reviewId: number;
  }[];
  photoReviewCount: number;
  productNumber?: string;
  institutionId?: number;
  className?: string;
}
const PhotoReviewDetailPortal = t0 => {
  const $ = _c(6);
  const {
    onClose
  } = t0;
  const isDesktopViewport = useMediaQuery(BREAKPOINTS.DESKTOP, true);
  const searchParams = useSearchParams();
  let t1;
  if ($[0] !== searchParams) {
    t1 = searchParams.get("detailReviewId");
    $[0] = searchParams;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const detailReviewIdParam = t1;
  const detailReviewId = detailReviewIdParam ? Number(detailReviewIdParam) : undefined;
  const t2 = !isDesktopViewport && !!detailReviewId;
  let t3;
  if ($[2] !== detailReviewId || $[3] !== onClose || $[4] !== t2) {
    t3 = <ReviewDetailSessionPortal open={t2} onClose={onClose} reviewId={detailReviewId} />;
    $[2] = detailReviewId;
    $[3] = onClose;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};
export const PhotoReviewSwiper = t0 => {
  const $ = _c(41);
  const {
    photoReviewList,
    photoReviewCount,
    productNumber,
    institutionId,
    className
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      align: "start",
      dragFree: true,
      containScroll: "trimSnaps"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [emblaRef] = useEmblaCarousel(t1);
  let t2;
  if ($[1] !== institutionId || $[2] !== photoReviewCount || $[3] !== photoReviewList || $[4] !== productNumber) {
    t2 = reviewId => {
      openResponsiveDialog({
        component: PhotoReviewsModalContent,
        modalHeader: "\uD3EC\uD1A0\uD6C4\uAE30",
        className: {
          modal: "max-w-[900px]"
        },
        props: {
          productNumber,
          institutionId,
          photoReviewList,
          photoReviewCount,
          initialReviewId: reviewId
        },
        drawerNoPadding: true
      });
    };
    $[1] = institutionId;
    $[2] = photoReviewCount;
    $[3] = photoReviewList;
    $[4] = productNumber;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const handleDetailReviewId = t2;
  if (photoReviewCount < 1) {
    return null;
  }
  let t3;
  if ($[6] !== className) {
    t3 = cn("flex flex-col pb-24", className);
    $[6] = className;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = cn("flex items-center justify-between py-12", "mobile-tablet:py-16");
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== photoReviewCount) {
    t5 = photoReviewCount.toLocaleString();
    $[9] = photoReviewCount;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t5) {
    t6 = <h2 className="font-700 text-Gray-900 typo-body2">포토후기 {t5}</h2>;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== institutionId || $[14] !== photoReviewCount || $[15] !== photoReviewList || $[16] !== productNumber) {
    t7 = () => openResponsiveDialog({
      component: PhotoReviewsModalContent,
      modalHeader: "\uD3EC\uD1A0\uD6C4\uAE30 \uC804\uCCB4\uBCF4\uAE30",
      className: {
        modal: "max-w-[900px]"
      },
      props: {
        institutionId,
        productNumber,
        photoReviewList,
        photoReviewCount
      }
    });
    $[13] = institutionId;
    $[14] = photoReviewCount;
    $[15] = photoReviewList;
    $[16] = productNumber;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <SvgChevronright className="size-12" />;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t7) {
    t9 = <Button theme="sub-text" className="flex size-fit items-center gap-4 px-4 py-10 font-400 text-Gray-900 typo-body4" onClick={t7}>더보기{t8}</Button>;
    $[19] = t7;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== t6 || $[22] !== t9) {
    t10 = <div className={t4}>{t6}{t9}</div>;
    $[21] = t6;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== handleDetailReviewId || $[25] !== photoReviewList) {
    let t12;
    if ($[27] !== handleDetailReviewId) {
      t12 = t13 => {
        const {
          fileUrl,
          reviewId: reviewId_0
        } = t13;
        return <div key={reviewId_0} className="w-fit flex-[0_0_auto]"><button type="button" className={cn("relative size-104 overflow-hidden rounded-small border border-Gray-black/5 transition-opacity duration-200", "hover:opacity-80", "active:opacity-80", "focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-B-500")} onClick={() => handleDetailReviewId(reviewId_0)}><Image src={fileUrl} alt={"\uD3EC\uD1A0\uD6C4\uAE30 \uC774\uBBF8\uC9C0"} width={850} height={850} className="size-full object-cover object-center" /></button></div>;
      };
      $[27] = handleDetailReviewId;
      $[28] = t12;
    } else {
      t12 = $[28];
    }
    t11 = photoReviewList.map(t12);
    $[24] = handleDetailReviewId;
    $[25] = photoReviewList;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[29] !== t11) {
    t12 = <div className="flex gap-8">{t11}</div>;
    $[29] = t11;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  let t13;
  if ($[31] !== emblaRef || $[32] !== t12) {
    t13 = <div className="w-full overflow-hidden" ref={emblaRef}>{t12}</div>;
    $[31] = emblaRef;
    $[32] = t12;
    $[33] = t13;
  } else {
    t13 = $[33];
  }
  let t14;
  if ($[34] !== handleDetailReviewId) {
    t14 = <Suspense fallback={null}><PhotoReviewDetailPortal onClose={() => handleDetailReviewId(undefined)} /></Suspense>;
    $[34] = handleDetailReviewId;
    $[35] = t14;
  } else {
    t14 = $[35];
  }
  let t15;
  if ($[36] !== t10 || $[37] !== t13 || $[38] !== t14 || $[39] !== t3) {
    t15 = <section className={t3}>{t10}{t13}{t14}</section>;
    $[36] = t10;
    $[37] = t13;
    $[38] = t14;
    $[39] = t3;
    $[40] = t15;
  } else {
    t15 = $[40];
  }
  return t15;
};